import React from "react";
import cx from "classnames";
import { PencilIcon } from "assets";
import ProfileButton from "pages/Profile/components/common/ProfileButton";
import { dataTestIds } from "data-testids";

interface Props {
  onClick?: () => void;
  editToPath?: string;
  editToClick?: () => void;
  className?: string;
  iconClassName?: string;
}

const EditButton = ({
  onClick,
  editToPath,
  editToClick,
  className,
  iconClassName,
}: Props) => {
  return (
    <ProfileButton
      onClick={onClick}
      to={editToPath}
      toClick={editToClick}
      className={cx("h-8 w-8 min-w-8 rounded-full", className)}
      data-testid={`${dataTestIds.profile["Profile.EditButton"]}`}
    >
      <PencilIcon width={16} height={16} className={iconClassName} />
    </ProfileButton>
  );
};

export default EditButton;
